<div class="row" style="margin-top: 5%; margin-bottom: 10%;">
    <div class="col-md-3">
        <div class="card">
            <img src="../../assets/img/Admin-Ico.png" alt="Avatar" style="width:100%">
            <div class="container">
                <h4><b>Admin</b></h4>
                <h5 class="trainingDescription">Learn how to setup, configure, and integrate RegScale for your organization's use.
                </h5>
                <div>
                    <a class="btn btn-primary" [routerLink]="['/trainingadmin']">View Videos</a>
                </div>
                <br>
            </div>
        </div>
    </div>
    <div class="col-md-3 ">
        <div class="card">
            <img src="../../assets/img/Practitioner-Ico.png" alt="Avatar" style="width:100%">
            <div class="container">
                <h4><b>Practictioner</b></h4>
                <h5 class="trainingDescription">Learn how to build out your automated compliance program using the RegScale modules and features.</h5>
                <div>
                    <a class="btn btn-primary" [routerLink]="['/trainingpractitioner']">View Videos</a>
                </div>
                <br>
            </div>
        </div>
    </div>
    <div class="col-md-3 ">
        <div class="card">
            <img src="../../assets/img/Auditer-Ico.png" alt="Avatar" style="width:100%">
            <div class="container">
                <h4><b>Auditor</b></h4>
                <h5 class="trainingDescription">Learn how to easily access the evidence and information needed to support your audit workflows.</h5>
                <div>
                    <a class="btn btn-primary" [routerLink]="['/trainingauditor']">View Videos</a>
                </div>
                <br>
            </div>
        </div>

    </div>
    <div class="col-md-3">
        <div class="card">
            <img src="../../assets/img/Executive-Ico.png" alt="Avatar" style="width:100%">
            <div class="container">
                <h4><b>Executive</b></h4>
                <h5 class="trainingDescription">Learn how to improve transparency, accountability, and insights with our real-time analytics and reporting. </h5>
                <div>
                    <a class="btn btn-primary" [routerLink]="['/trainingexecutive']">View Videos</a>
                </div>
                <br>
            </div>
        </div>
    </div>
</div>
